import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAmazon$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAmazon extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b8cb9d6ebf83a33686f3a5364f6489529a06b2fb', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '006652b8f6b41afc1e2a7383798f0e61bccfc924', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f886062448fb4c47ff861431526ac26c247b5845', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.43 14.998a.43.43 0 0 1-.484.05c-.571-.475-.747-.736-1.012-1.127l-.161-.237c-1.122 1.145-1.916 1.487-3.371 1.487-1.72 0-3.06-1.061-3.06-3.187 0-1.66.9-2.79 2.18-3.342.93-.41 2.17-.537 3.246-.647q.311-.031.6-.064v-.416c.003-.45.007-.953-.248-1.33-.25-.376-.728-.532-1.148-.532-.78 0-1.475.4-1.645 1.228-.035.185-.17.366-.354.374l-1.985-.212c-.166-.038-.35-.173-.304-.429.457-2.405 2.628-3.13 4.573-3.13.995 0 2.295.265 3.08 1.019.915.854.909 1.97.902 3.193l-.002.324v3.187c0 .855.317 1.282.65 1.732l.095.127.026.037c.133.184.161.405-.005.543-.418.348-1.16.996-1.568 1.358zm-2.445-2.816c.384-.675.383-1.31.382-2.06v-.551c-1.478 0-3.04.316-3.04 2.06 0 .882.457 1.48 1.242 1.48.576 0 1.09-.353 1.415-.929", fill: "currentColor" }), h("path", { key: 'bc29afd598d8c1e16fecae6f767cfbffb3a9b28e', d: "M3.92 15.246c2.54 1.549 6.471 3.946 12.737.964.27-.113.459.075.192.416-.27.344-2.42 2.317-6.034 2.317s-6.38-2.468-7.224-3.492c-.232-.266.035-.386.192-.289z", fill: "currentColor" }), h("path", { key: '73e50d9e43af8aea2d52317e454ba12193d28f14', d: "M16.86 15.023c.547-.068 1.418-.026 1.589.197.13.17-.005.933-.225 1.48-.222.545-.553.93-.736 1.078-.186.149-.322.091-.223-.132.102-.223.661-1.606.44-1.897-.206-.268-1.137-.17-1.57-.126l-.088.01-.224.022c-.187.021-.237.027-.264-.03-.072-.202.752-.537 1.3-.602", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-amazon", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-amazon"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-amazon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAmazon$1);
            }
            break;
    } });
}

const CosmosIconAmazon = CosmosIconAmazon$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAmazon, defineCustomElement };
